import {UserActions} from '../constants/User'

let actions = {
    loginUser: function(user){
        return{
            type: UserActions.SET_USER_LOGIN,
            payload: {...user}
        }
    },
    logoutUser: function(){
        return{
            type: UserActions.SET_USER_LOGOUT
        }
    }
}

export default actions